module.exports = __webpack_public_path__ + "static/img/trafficActivitiesbg.01a5052.png";